module.exports = __webpack_public_path__ + "static/media/cq_stampa b.d9402f8d.svg";